<template>
    <C1Modal
        v-if="isModalOpen"
        v-model="isOpen"
        modal-content-class="af-modal work-experience-modal"
        size="xl"
        variant="var2"
        @close="closeModal()"
        @hidden="close"
    >
        <template v-slot:headerTitle>
            {{ $t('resume.remove') }}
        </template>
        <template v-slot:bodyText>
            Are you sure you want to remove '{{ resume.file_name }}'?
        </template>

        <template v-slot:footer>
            <C1Button
                :is-busy="loader.destroy"
                variant="primary"
                class="afu-flex-1"
                @click="destroyResume()"
            >
                <FontAwesomeIcon
                    :icon="['fal', 'trash-alt']"
                    class="afu-mr-2"
                    fixed-width
                />
                {{ $t('label.confirm_remove') }}
            </C1Button>
            <C1Button
                :disabled="loader.destroy"
                variant="outline-secondary"
                class="afu-flex-1"
                @click="$emit('closeModal')"
            >
                {{ $t('label.cancel') }}
            </C1Button>
        </template>
    </C1Modal>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Modal from '@/components/C1Components/C1Modal';

    export default {
        name: 'ResumeModalDestroy',

        components: {
            C1Button,
            C1Modal,
        },

        props: {
            resume: {
                type: Object,
                default: () => ({}),
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isOpen: false,
                loader: {
                    destroy: false,
                },
            };
        },

        created() {
            this.openModal();
        },

        beforeDestroy() {
            this.closeModal();
        },

        methods: {
            ...mapActions('me', {
                $_destroyResume: 'destroyResume',
            }),

            ...mapMutations('me', {
                $_DESTROY_RESUME: 'DESTROY_RESUME',
            }),

            destroyResume() {
                this.loader.destroy = true;
                this.$_destroyResume(this.resume.id).then(() => {
                    this.$_DESTROY_RESUME(this.resume.id);
                    this.closeModal();
                }).finally(() => {
                    this.loader.destroy = false;
                });
            },

            close() {
                this.$emit('close');
            },

            openModal() {
                this.isOpen = true;
            },

            closeModal() {
                this.isOpen = false;
                this.$emit('closeModal');
            },
        },
    };
</script>
